export const ONE_COLOR_SWATCH_WIDTH = 28
export const TILE_PADDING_OFFSET = 16
